import React from 'react';

// Utils //
import contentfulRenderOptions from '../../../utils/contentfulRenderOption';
import { isMobile } from '../../../utils/helpers';

// Interface //
import { ReferenciaContenido } from '../../../interfaces/ReferenciaContenido';

// Styles //
import "./ConsiderationsMpc.scss";

const ConsiderationsMpc = (props: ReferenciaContenido) => {
    const {tituloGeneral, descripcion, imagenPrincipal} = props;

    return (
        <div className={`o-consideration-mpc ${props.contentful_id === "1IvSNCNkPcia6st67uvcmF" ? "o-consideration-mpc--important" : ""}`}>
            <div className="o-consideration-mpc__inner">
                <div className="container">
                    <div className="o-consideration-mpc__box">
                        <div className="o-consideration-mpc__box__image">
                            <img src={imagenPrincipal.file.url} alt="" />
                        </div>
                        <div className="o-consideration-mpc__box__text">
                            <h3>{tituloGeneral}</h3>
                            {descripcion && (props.contentful_id === "1IvSNCNkPcia6st67uvcmF" && isMobile()) && contentfulRenderOptions(props.descripcion.json)}
                            <div className="o-consideration-mpc__box__text__image">
                                <img src={imagenPrincipal.file.url} alt="" />
                            </div>
                            {descripcion && !(props.contentful_id === "1IvSNCNkPcia6st67uvcmF" && isMobile()) && contentfulRenderOptions(props.descripcion.json)}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ConsiderationsMpc